// Local entry for `@s-ui/decorators`.
//
// Aliased in `vite.config.js`, so every `import ... from '@s-ui/decorators'` in `packages/domain`
// and `packages/ui` lands here. Everything comes from the SWC-compatible shim except `tracer`: the
// shim's is a no-op, so under Vite no use case reported `frontend.mt.tracer.*` and the use-case
// panels of the cutover dashboard went empty. On the server we use the app's tracer, which reports
// through the DataDog reporter `initDataDogReporter` installs. In the browser it stays a no-op, as
// there is no reporter there and the fallback would `console.log` every use case.
import {tracer as noopTracer} from '@adv-mt/shim-sui-decorators'

import serverTracer from '../../server/decorators/tracer/index.js'

export {AsyncInlineError, cache, inlineError, streamify, default} from '@adv-mt/shim-sui-decorators'

export const tracer = typeof window === 'undefined' ? serverTracer : noopTracer
